import { API_USER_SERVICE } from "../config/Constants";
import { IPincodeRequestDTO } from "../interfaces/DeliverySettings";
import { getRequest, postRequest, putRequest, deleteRequest } from "./Rest";

// Pincode APIs

export const getAllPincodes = async () => {
    const path = `${API_USER_SERVICE}/delivery-pincodes`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createPincode = async (dto: IPincodeRequestDTO) => {
    const path = `${API_USER_SERVICE}/delivery-pincodes`;
    const response = await postRequest(path, dto);
    return response;
};

export const updatePincode = async (id: number, dto: IPincodeRequestDTO) => {
    const path = `${API_USER_SERVICE}/delivery-pincodes/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const deletePincode = async (id: number) => {
    const path = `${API_USER_SERVICE}/delivery-pincodes/${id}`;
    const response = await deleteRequest(path);
    return response;
};